/**
 * This is temporary solution class of DI problem:
 * We cannot inject Angular services into AngularJS services directly.
 * This will throw an error at the login screen (suppressed below) but injection will work further down the pipeline
 * 
 * With this class you can inject `angular.auto.IInjectorService` with DI in AngularJS service,
 * and then make a property inside class:
 *
 * `private readonly someService = new HybridServiceAccessor<SomeService>("someService", this.injector);`
 *
 * and use it like singleton instance:
 *
 * `const someData = this.someService.service.someData;`
 *
 * This class should be removed immediately after whole application (or at least
 * every AngularJS service) is migrated to Angular.
 *
 */
export class HybridServiceAccessor<T> {
    private _service: T;

    get service(): T {
        if (!this._service) {
            try {
                this._service = this.injector.get(this.name);
            }
            catch (error) {
                console.warn(`Cannot access "${this.name}" at this stage due to ${error}`);
            }
        }

        return this._service;
    }

    constructor(
        private readonly name: string,
        private readonly injector: angular.auto.IInjectorService
    ) { }
}
